import { ConfigurationConstant } from "./ConfigurationConstant";

const ConfigurationAction = {};

ConfigurationAction.getConfigurationTableAction = () => ({
  type: ConfigurationConstant.CONFIGURATION_TABLE_SAGA,
});

ConfigurationAction.UdateConfigurationCancelAction = (payload) => {
  return {
    type: ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_SAGA,
    payload: payload,
  };
};

export { ConfigurationAction };
